export default {"src":"/_next/static/media/logo.340ff3e8.svg","height":68,"width":152,"blurWidth":0,"blurHeight":0};